/* eslint-disable indent */

import React from 'react';
const { useReducer } = React;

const initialState = {
	loading: false,
	success: '',
	error: ''
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'REQUEST':
			return {
				...initialState,
				loading: true
			};
		case 'SUCCESS':
			return {
				...state,
				loading: false,
				success: action.success,
				error: ''
			};
		case 'FAIL':
			return {
				...state,
				loading: false,
				success: '',
				error: action.error
			};
		default:
			return state;
	}
};

const useAsyncState = () => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const actions = {
		request: (): any => dispatch({ type: 'REQUEST' }),
		success: (success: any = true): any =>
			dispatch({ type: 'SUCCESS', success }),
		fail: (error: any): any => dispatch({ type: 'FAIL', error })
	};
	return [state, actions];
};

export default useAsyncState;
